import React from 'react';

import { TwoPaneLayout } from '@metarouter-private/mr-mui';
import { MrAppMain } from '@ion/components';

import Documentation from './components/Documentation';
import PipelineTagsPane from './components/PipelineTagsPane';

export default function TagsPage() {
  return (
    <MrAppMain styleNames="noBackground">
      <TwoPaneLayout paneOne={<Documentation />} paneTwo={<PipelineTagsPane />} />
    </MrAppMain>
  );
}
